import * as React from "react";
import { useLocalStorage } from "@grandvisionhq/utils";
import { handleConversionEvent } from "./AlgoliaAnalyticsHelpers.js";
const ALGOLIA_ANALYTICS_STORAGE_KEY = "algoliaAnalyticsData";
const useAlgoliaAnalytics = () => {
  const [data, setData] = useLocalStorage(ALGOLIA_ANALYTICS_STORAGE_KEY, {
    queryId: void 0,
    searchIndex: ""
  });
  const saveData = React.useCallback((newData) => {
    setData(newData);
  }, []);
  const clearQueryId = React.useCallback(() => {
    setData((data2 = {}) => ({ ...data2, queryId: void 0 }));
  }, [data]);
  const handleConversionEvent$1 = React.useCallback(
    (objectId, queryId) => {
      if (data) {
        handleConversionEvent({
          objectIds: objectId,
          searchIndex: data.searchIndex,
          queryId
        });
      }
    },
    [data]
  );
  return { algoliaAnalyticsData: data, saveData, clearQueryId, handleConversionEvent: handleConversionEvent$1 };
};
export {
  ALGOLIA_ANALYTICS_STORAGE_KEY,
  useAlgoliaAnalytics as default,
  useAlgoliaAnalytics
};
//# sourceMappingURL=useAlgoliaAnalytics.js.map
